<template>
  <div class="section sec3" :class="{activepage:showIndex==2}">
    <div class="sec-contain">
      <div class="sec-title">随时随地的移动工作</div>
      <div class="sec-body">
        <div class="icon-box">
          <div
            class="icon-item"
            v-for="(iconItem,index) in workList"
            :key="iconItem.mormalurl"
            @mouseenter="changeActive(index)"
          >
            <div class="icon">
              <img :src="iconItem.activeurl" alt v-if="index==iconIndex" />
              <img :src="iconItem.normalurl" alt v-else />
            </div>
            <div class="icon-text">
              <div class="icon-title">{{iconItem.title}}</div>
              <div class="icon-content">{{iconItem.content}}</div>
            </div>
          </div>
        </div>
        <div class="images-box">
          <!-- <div class="image-item" v-for="(imgItem,imgIndex)" in imagesList :key=></div> -->
          <img :src="imagesLsit[iconIndex].url" alt="医信管家" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ["showIndex","workList"],
    data() {
        return {
            iconIndex: 0,
            imagesLsit: [
                { url: require("../../assets/images/page3/image_app2.png") },
                { url: require("../../assets/images/page3/image_wechat2.png") },
                { url: require("../../assets/images/page3/image_application2.png") }
            ]
        };
    },
    methods: {
        changeActive(index) {
            this.iconIndex = index;
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sec3 {
  background: url("../../assets/images/page3/bg_3.png") center no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.sec-contain {
  width: 1049px;
  height: 628px;
  margin: 0 auto;
  position: absolute;
  top: calc(50% + 60px);
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.sec3 .sec-title {
  font-size: 36px;
  color: #333;
  line-height: 1;
  margin-bottom: 44px;
}

.sec-body {
  height: 100%;
  width: 100%;
  display: flex;
}

.sec-body .icon-box {
  width: 520px;
  margin-right: 40px;
  margin-top: 47px;
  float: left;
}

.sec-body .icon-item {
  height: 96px;
  cursor: pointer;
  position: relative;
  padding-left: 111px;
  margin-bottom: 50px;
}

.sec-body .icon-item .icon {
  position: absolute;
  left: 0;
}

.sec-body .icon-item .icon-text {
  width: 350px;
  text-align: left;
}

.sec-body .icon-item .icon-title {
  font-size: 24px;
  font-weight: bold;
  color: #157eff;
  line-height: 1;
  margin-bottom: 16px;
}
.sec-body .icon-item .icon-content {
  font-size: 16px;
  line-height: 24px;
  color: #555;
}

.sec-body .images-box {
  float: left;
}

.sec3.activepage .sec-title {
  animation: title 1s linear;
  animation-fill-mode: forwards;
}

.sec3.activepage .icon-box {
  animation: leftIcon 1.5s linear;
  animation-fill-mode: forwards;
}
.sec3.activepage .images-box {
  animation: rightImg 1.5s linear;
  animation-fill-mode: forwards;
}

@keyframes title {
  0% {
    opacity: 0;
    margin-left: 150px;
  }
  100% {
    opacity: 1;
    margin-left: 0;
  }
}

@keyframes leftIcon {
  0% {
    margin-top: 0;
  }
  100% {
    margin-top: 70px;
  }
}
@keyframes rightImg {
  0% {
    margin-top: 70px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
}

@media screen and (max-width: 1366px)  {
  .sec-contain {
    top: calc(50% + 80px);
  }
  .sec3 .sec-title{
    margin-bottom:20px;
  }
}

@media screen and (min-width: 1920px)  {
  .sec-contain {
    top: 55%;
  }

  .sec3 .sec-title{
    margin-bottom:60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/thirdPage.vue